export default "__VITE_ASSET__1a63017b__"